import { render, staticRenderFns } from "./testPage.vue?vue&type=template&id=164aca08&scoped=true"
import script from "./testPage.vue?vue&type=script&lang=js"
export * from "./testPage.vue?vue&type=script&lang=js"
import style0 from "./testPage.vue?vue&type=style&index=0&id=164aca08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164aca08",
  null
  
)

export default component.exports